import React, { useState } from 'react';
import { Routes, Route } from "react-router-dom";
//import Navbar from "./components/Navbar_vecchio";
import Gestione_Alunno from "./components/Alunno_x0_0";
import Gestione_Tutor from "./components/Tutor_x0_0";
import Gestione_Classi from "./components/Classi_x0_0";

import Nuova_Ditta from "./components/Ditta_x0_0";
import Progetto from "./components/Progetto_x0_0";

// import Home from "./components/Home";
// import Notes from "./components/Notes";
//import Immagini_S3 from "./components/Immagini_s3";
import Monitor from "./components/Monitor_x0_gestione_presenze";
import Alunno_form_mail from "./components/Alunno_form_risposta_mail";
import Ditta_form_mail from "./components/Ditta_form_risposta_mail";
import Ditta_form_mail_uscita from "./components/Ditta_form_mail_uscita";

import Progetto_form_valutazione_dalla_mail from "./components/Progetto_valutazione_dalla_mail";
import Monitor_conferma_inizio_stage from "./components/Monitor_conferma_inizio_stage";
import NavScrollExample from "./component_auth0/Navbar_new";
import Prova_codice from "./component_auth0/Prova_codice";
import Upload_documenti_QRcode from "./components_qrcode/qrcode_X0.jsx";

import Home_page from "./component_auth0/home.jsx";
import Google_maps from "./components/Maps_x0_pagina.jsx";
import { useLocation } from "react-router-dom";
   

function App() {
  const [account_dati, SET_account_dati] = useState({});
  const search = useLocation().search;
  const pdf = new URLSearchParams(search).get('pdf');
   
  return (
    <>
      {!pdf && 
            <NavScrollExample  SET_account_dati={SET_account_dati} account_dati={account_dati} />
      }
      <Routes>

 
        <Route path="/" element={<Home_page  account_dati={account_dati} />} />
        <Route path="url_qrcode" element={<Upload_documenti_QRcode account_dati={account_dati} />} />

        <Route path="url_tutor" element={<Gestione_Tutor account_dati={account_dati} />} />
        <Route path="url_classi" element={<Gestione_Classi account_dati={account_dati} />} />
 
        <Route path="url_alunno" element={<Gestione_Alunno account_dati={account_dati} />} />
        <Route path="url_ditte" element={<Nuova_Ditta account_dati={account_dati} />} />
        <Route path="url_google_maps" element={<Google_maps account_dati={account_dati} />} />
        <Route path="url_prova_codice" element={<Prova_codice account_dati={account_dati} />} />

        <Route path="url_progetti" element={<Progetto account_dati={account_dati} />} />
        <Route path="url_monitor_ditte" element={<Monitor account_dati={account_dati} />} />
        <Route path="url_form_dati_alunno" element={<Alunno_form_mail account_dati={account_dati} />} />
        <Route path="url_form_dati_ditta" element={<Ditta_form_mail account_dati={account_dati} />} />
        <Route path="url_form_ditta_uscita_form" element={<Ditta_form_mail_uscita account_dati={account_dati} />} />
        <Route path="url_form_valutazione_progetto" element={<Progetto_form_valutazione_dalla_mail account_dati={account_dati} />} />

        <Route path="url_risposta_mail_iniziale" element={<Monitor_conferma_inizio_stage account_dati={account_dati} />} />

     
      </Routes>
    

    </>
  );
}

export default App;
